export const TicketsTypes = {
  SHOW_TICKET: 'SHOW_TICKET',
  SHOW_TICKET_DETAIL: 'SHOW_TICKET_DETAIL',
  NEW_TICKET: 'NEW_TICKET',
  SEND_TICKET_MESSAGE: 'SEND_TICKET_MESSAGE',
}
